import { Box } from '@mui/material';

import { Shimmer } from './Shimmer';

interface StatsCardsSkeletonProps {
  count?: number;
  /** Mirror the real row's grid so the layout doesn't reflow on load. */
  columns?: { xs?: string; sm?: string; md?: string; lg?: string };
}

const DEFAULT_COLUMNS = { xs: '1fr', sm: 'repeat(3, 1fr)' };

/**
 * Placeholder for StatsCardsRow — same card chrome, same responsive grid, with
 * the label, icon tile and figure replaced by shimmer blocks.
 */
export const StatsCardsSkeleton = ({ count = 3, columns = DEFAULT_COLUMNS }: StatsCardsSkeletonProps) => (
  <Box sx={{ display: 'grid', gridTemplateColumns: columns, gap: '16px' }}>
    {Array.from({ length: count }, (_, i) => (
      <Box
        key={i}
        sx={(theme) => ({
          bgcolor: 'white', border: `1px solid ${theme.palette.grey[200]}`, borderRadius: '16px',
          px: '20px', pt: '18px', pb: '20px',
          boxShadow: '0px 1px 3px rgba(0,0,0,0.06)',
          display: 'flex', flexDirection: 'column', gap: '10px',
        })}
      >
        <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '12px' }}>
          <Shimmer height={11} width="55%" sx={{ mt: '2px' }} />
          <Shimmer height={32} width={32} radius="8px" />
        </Box>
        {/* Matches the real figure's responsive font size. */}
        <Shimmer height={{ xs: 24, sm: 28, md: 32 }} width="45%" />
      </Box>
    ))}
  </Box>
);
